import { render, staticRenderFns } from "./Disciplina.vue?vue&type=template&id=ca3356f0&"
import script from "./Disciplina.vue?vue&type=script&lang=js&"
export * from "./Disciplina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports